import Image from 'next/image';

import classnames from 'classnames';

const className = classnames(
  'flex',
  'flex-1',
  'flex-col',
  'justify-center',
  'items-center'
);

interface Props {
  alt: string;
}

const BrandJumbotron = ({ alt }: Props) => (
  <div className={className}>
    <div>
      <Image
        src={`/images/brands/personly-logo.svg`}
        width={175}
        height={175}
        alt={alt}
        priority
      />
    </div>
  </div>
);

export default BrandJumbotron;
